import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import TooltipCommon from 'components/common/TooltipCommon';
import TooltipCommonMobile from 'components/common/TooltipCommon/mobile';
import { getFullNameReceiver } from 'components/FormEditReceiver/func';
import {
  BUSINESS_OF_RECEIVER_TYPE,
  DESKTOP_MIN_WIDTH,
  EDIT_RECEIVER_FISTNAME_NAME,
  EDIT_RECEIVER_FULLNAME_NAME,
  EDIT_RECEIVER_GENDER_NAME,
  EDIT_RECEIVER_LASTNAME_NAME,
  EDIT_RECEIVER_MOBILE_NAME,
  EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD,
  EDIT_RECEIVER_PHONE_NAME,
  EDIT_RECEIVER_RELATIONSHIP_NAME,
  EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME,
  METHOD_BANK,
} from 'constants';
import useUpdateReceiver from 'features/receiver/hooks/useUpdateReceiver';
import { Fade } from 'helpers/animation';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import useReceiver from 'hooks/receiver/useReceiver';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputSelectTypeOfReceiverRadio = ({
  countryConfig,
  information,
  setInformation,
  validation,
  setValidation,
  isDisabled,
  isEdit = false,
}) => {
  const { t } = useLang();
  const { isMobile, isTablet } = useDetectDevice();

  const { currentReceiver } = useFormAddReceiverStore();
  const { getReceiverRelationship } = useUpdateReceiver();
  const { firstName, lastName, relationship, address } = currentReceiver || {};

  const { dmList } = countryConfig || {};

  const validRef = useRef(null);

  const currentReceiverType =
    information[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME];
  const isReceiverOfIndividualType = currentReceiverType === 1;
  const isReceiverOfBusinessType = currentReceiverType === 2;

  const currentReceiverRelationship =
    information[EDIT_RECEIVER_RELATIONSHIP_NAME] ||
    getReceiverRelationship({
      value: relationship,
      isReceiverOfIndividualType,
      isReceiverOfBusinessType,
    });

  const { isCreateBusinessReceiver, isCreateIndividualReceiver } =
    useReceiver();

  const dmOfBank = dmList?.find((dm) => dm?.name === METHOD_BANK);
  const isReceiverOfBusinessTypeDisable =
    !dmOfBank || dmOfBank?.currencies?.some((c) => !c?.businessReceiver);
  const selectTypeValidation =
    validation[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME];

  useEffect(() => {
    if (selectTypeValidation) {
      validRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [selectTypeValidation]);

  const handleOnChange = (value) => {
    if (currentReceiverType === value) return;

    const isReceiverOfIndividualType = value === 1;
    const isReceiverOfBusinessType = value === 2;

    const newReceiverRelationship =
      getReceiverRelationship({
        isReceiverOfBusinessType,
        isReceiverOfIndividualType,
        value: currentReceiverRelationship?.key,
      }) ||
      getReceiverRelationship({
        isReceiverOfBusinessType,
        isReceiverOfIndividualType,
        value: relationship,
      });
    let newInformation = {
      ...information,
      [EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]: value,
    };

    if (isReceiverOfIndividualType) {
      newInformation = {
        ...newInformation,
        [EDIT_RECEIVER_FISTNAME_NAME]: firstName,
        [EDIT_RECEIVER_LASTNAME_NAME]: lastName,
        [EDIT_RECEIVER_FULLNAME_NAME]: getFullNameReceiver({
          isReceiverOfIndividualType,
          lastName,
          firstName,
          countryCode: address?.country?.code,
        }),
        [EDIT_RECEIVER_GENDER_NAME]: '',
        [EDIT_RECEIVER_RELATIONSHIP_NAME]:
          newInformation?.relationshipIndividualInformationCache ||
          newReceiverRelationship,
      };
    }

    if (isReceiverOfBusinessType) {
      newInformation = {
        ...newInformation,
        [EDIT_RECEIVER_FISTNAME_NAME]: getFullNameReceiver({
          isReceiverOfBusinessType,
          lastName,
          firstName,
          countryCode: address?.country?.code,
        }),
        [EDIT_RECEIVER_LASTNAME_NAME]: '',
        [EDIT_RECEIVER_FULLNAME_NAME]: getFullNameReceiver({
          isReceiverOfBusinessType,
          lastName,
          firstName,
          countryCode: address?.country?.code,
        }),
        [EDIT_RECEIVER_GENDER_NAME]: BUSINESS_OF_RECEIVER_TYPE,
        [EDIT_RECEIVER_RELATIONSHIP_NAME]: newReceiverRelationship,
        relationshipIndividualInformationCache:
          information[EDIT_RECEIVER_RELATIONSHIP_NAME],
      };
    }

    console.log(
      `⭐ FormInputSelectTypeOfReceiverRadio 👉 handleOnChange ➡️ newInformation ↩`,
      newInformation,
    );
    setInformation(newInformation);

    const newValidation = {
      ...validation,
      [EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]: '',
      [EDIT_RECEIVER_FISTNAME_NAME]: '',
      [EDIT_RECEIVER_LASTNAME_NAME]: '',
      [EDIT_RECEIVER_FULLNAME_NAME]: '',
      [EDIT_RECEIVER_GENDER_NAME]: '',
      [EDIT_RECEIVER_MOBILE_NAME]: '',
      [EDIT_RECEIVER_PHONE_NAME]: '',
      [EDIT_RECEIVER_RELATIONSHIP_NAME]: '',
    };
    console.log(
      `⭐ FormInputSelectTypeOfReceiverRadio 👉 handleOnChange ➡️ newValidation ↩`,
      newValidation,
    );
    setValidation(newValidation);
  };

  const handleFormCheckRadio1 = () => {
    if (isDisabled || isCreateIndividualReceiver) return;
    handleOnChange(1);
  };
  const renderFormCheckRadio1 = () => {
    if (isEdit && isReceiverOfBusinessType) return null;
    const formCheckRadioClassName1 =
      EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME + '1';

    return (
      <FormCheckboxRadio
        name={EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME}
        className={`${formCheckRadioClassName1} ${
          isReceiverOfIndividualType && 'active'
        }`}
        label={t('label_individual_receiver')}
        isChecked={isReceiverOfIndividualType}
        onClick={handleFormCheckRadio1}
      />
    );
  };

  const handleFormCheckRadio2 = () => {
    if (
      isDisabled ||
      isReceiverOfBusinessTypeDisable ||
      isCreateBusinessReceiver
    )
      return;
    handleOnChange(2);
  };
  const renderFormCheckRadio2 = () => {
    if (isEdit && isReceiverOfIndividualType) return null;

    const formCheckRadioClassName2 =
      EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME + '2';

    return (
      <>
        <FormCheckboxRadio
          name={EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME}
          className={`${formCheckRadioClassName2} ${
            isReceiverOfBusinessType && 'active'
          }`}
          label={t('label_business_receiver')}
          isChecked={isReceiverOfBusinessType}
          onClick={handleFormCheckRadio2}
          styles={{ marginRight: '4px' }}
          isDisabled={isReceiverOfBusinessTypeDisable}
        />
        {isReceiverOfBusinessTypeDisable && (
          <Tooltip>
            {isMobile || isTablet ? (
              <TooltipCommonMobile
                text={t('form_business_receiver_type_tooltip')}
                name={EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME}
                label={t(
                  EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD.label,
                )}
              />
            ) : (
              <TooltipCommon text={t('form_business_receiver_type_tooltip')} />
            )}
          </Tooltip>
        )}
      </>
    );
  };

  return (
    <FormGroupStyled>
      <FormLabel onClick={(e) => e.preventDefault()}>
        {t(EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD.label)}
        <span>*</span>
      </FormLabel>
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
      {Boolean(selectTypeValidation) && (
        <FormControlFeedback ref={validRef} hidden={false} type="invalid">
          {t(selectTypeValidation)}
        </FormControlFeedback>
      )}
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  display: table;
  width: 100%;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
    clear: both;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  display: block;
  color: var(--ds-c-grey-dark);
  margin-bottom: 16px;

  span {
    color: var(--c-required);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

const FormControlFeedback = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  color: var(--ds-c-red);
  position: absolute;
  margin-top: 4px;
  margin-bottom: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

const Tooltip = styled.div`
  display: inline-flex;
`;

export default FormInputSelectTypeOfReceiverRadio;
